export const PRODUCT_LIST_REQUEST='PRODUCT_LIST_REQUEST'
export const PRODUCT_LIST_SUCCESS='PRODUCT_LIST_SUCCESS'
export const PRODUCT_LIST_FAILURE='PRODUCT_LIST_FAILURE'

export const SELLER_PRODUCT_LIST_REQUEST='SELLER_PRODUCT_LIST_REQUEST'
export const SELLER_PRODUCT_LIST_SUCCESS='SELLER_PRODUCT_LIST_SUCCESS'
export const SELLER_PRODUCT_LIST_FAILURE='SELLER_PRODUCT_LIST_FAILURE'


export const PRODUCT_DETAILS_REQUEST='PRODUCT_DETAILS_REQUEST'
export const PRODUCT_DETAILS_SUCCESS='PRODUCT_DETAILS_SUCCESS'
export const PRODUCT_DETAILS_FAILURE='PRODUCT_DETAILS_FAILURE'


export const IMG_PRODUCT_DETAILS_REQUEST='IMG_PRODUCT_DETAILS_REQUEST'
export const IMG_PRODUCT_DETAILS_SUCCESS='IMG_PRODUCT_DETAILS_SUCCESS'
export const IMG_PRODUCT_DETAILS_FAILURE='IMG_PRODUCT_DETAILS_FAILURE'

// export const FEATURE_DATA='FEATURE_DATA'
export const FEATURE_DATA_REQUEST='FEATURE_DATA_REQUEST'
export const FEATURE_DATA_SUCCESS='FEATURE_DATA_SUCCESS'
export const FEATURE_DATA_FAILURE='FEATURE_DATA_FAILURE'

// export const FEATURE_PYDB_REQUEST='FEATURE_PYDB_REQUEST'
// export const FEATURE_PYDB_SUCCESS='FEATURE_PYDB_SUCCESS'
// export const FEATURE_PYDB_FAILURE='FEATURE_PYDB_FAILURE'